// Sentry should be initialized as soon as possible
import { initializeSentry } from '@cc/common/sentry';
initializeSentry();

import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './css/index.scss';

// there is logic in the index.html that uses this flag
window.reactLoaded = true;
const container = document.getElementById('root');
const root = createRoot(container);
root.render(<App />);

// After React paints its first frame, fade out the skeleton overlay
requestAnimationFrame(() => {
    requestAnimationFrame(() => {
        const skeleton = document.getElementById('app-skeleton');
        if (skeleton) {
            skeleton.classList.add('login-skeleton--fade-out');
            skeleton.addEventListener('transitionend', () => skeleton.remove(), { once: true });
        }
    });
});
